/**
 * @file geneDiseasegeneDiseaseAnnotationsEvidenceFind.saga.js
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Nov 24, 2023 6:48 PM
 */
import { call, put, takeLatest } from 'redux-saga/effects';
import axiosClient from 'src/services/axiosClient.js';

import standardMessages from 'src/services/notifications/standardMessages';

import {
    enqueueMessage,
} from 'src/store/actions/global.actions';

import { stringExists } from 'src/@common/utilities';

import {
    VARIANT_GENE_DISEASE_CLASSIFICATION_ANNOTATIONS_FIND_REQUEST,
    geneDiseaseClassificationAnnotationsFindSuccess,
    geneDiseaseClassificationAnnotationsFindFailure,
} from 'src/store/actions/variant/variantDb.actions';

import {
    geneDiseaseClassificationAnnotationsDialogSet,
} from 'src/store/actions/variant/variantPages.actions';

import { dataLoadingSet } from 'src/store/actions/global.actions';
import handleSagaErrors from 'src/store/sagas/handleSagaErrors';

function callApi(payload) {
    const url = '/variant/geneDiseaseClassification/annotations/find';

    const baseUrl = import.meta.env.VITE_APP_API_BASE_URL;

    const config = {
        method: 'post',
        baseURL: baseUrl,
        url,
        data: {
            geneDiseaseClassificationId: payload.geneDiseaseClassificationId,
            variantId: payload.variantId,
        },

    };

    return new Promise((resolve, reject) => {
        axiosClient(config)
            .then((response) => {
                resolve(response.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

function* requestSaga(action) {

    try {
        yield put(dataLoadingSet(true));

        const resp = yield call(callApi, action.payload);

        if (resp.payload.errorExists === true && stringExists(resp.payload.serverMessage)) {
            yield put(enqueueMessage(
                resp.payload.serverMessage,
                standardMessages.generalInfoMessage.options)
            );
        }

        yield put(geneDiseaseClassificationAnnotationsFindSuccess(resp.payload));
        yield put(geneDiseaseClassificationAnnotationsDialogSet(true));

    } catch (error) {
        yield put(geneDiseaseClassificationAnnotationsFindFailure(error));
        handleSagaErrors(error);
    } finally {
        yield put(dataLoadingSet(false));
    }

}

export default function* requestMonitor() {
    yield takeLatest(VARIANT_GENE_DISEASE_CLASSIFICATION_ANNOTATIONS_FIND_REQUEST, requestSaga);
}
